import { NavLink } from 'react-router-dom';
import MethodBadge from './MethodBadge';
import { useRecentStore } from '@/stores/recent.store';
import { timeAgo } from '@/lib/time-ago';
import type { Method } from '@/lib/tokens';

export default function RecentSection() {
    const entries = useRecentStore((s) => s.entries);
    const clear = useRecentStore((s) => s.clear);

    if (entries.length === 0) return null;

    return (
        <div className="mb-4">
            <div className="px-3 mb-1 flex items-center justify-between">
                <h3 className="text-[10px] font-semibold uppercase tracking-wider text-ghost">
                    Terakhir Dibuka
                </h3>
                <button
                    type="button"
                    onClick={clear}
                    className="text-[10px] uppercase tracking-wider text-ghost hover:text-ink transition-colors"
                    aria-label="Hapus daftar endpoint terakhir dibuka"
                >
                    Hapus
                </button>
            </div>
            <ul className="space-y-0.5">
                {entries.map((e) => {
                    const methodUpper = e.method.toUpperCase() as Method;
                    return (
                        <li key={e.operationId}>
                            <NavLink
                                to={`/r/${e.operationId}`}
                                className={({ isActive }) =>
                                    `flex items-center gap-2 px-2 py-1.5 rounded-md text-[13px] transition-colors ${
                                        isActive
                                            ? 'text-ink'
                                            : 'text-muted hover:text-ink hover:bg-bg-hover'
                                    }`
                                }
                                style={({ isActive }) => isActive ? { backgroundColor: 'var(--surface-active)' } : undefined}
                                title={`${methodUpper} ${e.path}`}
                            >
                                <MethodBadge method={methodUpper} size="xs" />
                                <span className="truncate flex-1">{e.summary}</span>
                                <span className="text-[10px] text-ghost shrink-0">{timeAgo(e.ts)}</span>
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
